<template>
  <v-app class="app-main">
    <div class="container">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="6" class="d-flex align-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="searchQuery" placeholder="Pesquisar" solo hide-details class="mr-2"
                @keyup.enter="searchProjects()" @input="searchFilter" v-bind="attrs" v-on="on" />
            </template>
            <v-list v-show="filteredResults.length > 0">
              <v-list-item v-for="(item, index) in filteredResults" :key="index" :href="projectPath(item)">
                <v-list-item-avatar tile>
                  <v-img :src="item.project_thumb"></v-img>
                </v-list-item-avatar>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn class="btn-search" @click="searchProjects">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <div class="tags-row">
        <button class="arrow-button left-arrow" @click="scrollTags(-1)" aria-label="Previous tags">
          <v-icon>mdi-arrow-left</v-icon>
        </button>
        <div class="tags-slider" ref="tagsSlider">
          <v-btn size="x-small" density="compact" v-for="tag in tags" :key="tag.id" class="tag-button" depressed
            :class="{ active: gender_id === tag.id }" @click="handleFilter(tag.id, 'gender')">
            {{ tag.name }}
          </v-btn>
        </div>
        <button class="arrow-button right-arrow" @click="scrollTags(1)" aria-label="Next tags">
          <v-icon>mdi-arrow-right</v-icon>
        </button>
      </div>

      <div class="tags-row">
        <div class="tags-container">
          <div class="tag-group">
            <v-btn class="tag-button" v-for="tag in tagsLang" :key="tag.id" depressed
              :class="{ active: language_id === tag.id }" @click="handleFilter(tag.id, 'language')">
              {{ tag.name }}
            </v-btn>
          </div>
          <div class="tag-group">
            <v-btn class="tag-button" v-for="tag in tagsTypes" :key="tag.id" depressed
              :class="{ active: type_id === tag.id }" @click="handleFilter(tag.id, 'type')">
              {{ tag.name }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- Restante do código mantido como estava -->
    <div class="container-result" v-if="projects.length">
      <h1 class="result-title">Todos os resultados...</h1>
      <div class="result-item" v-for="(result, index) in projects" :key="index">
        <ProjectCard :cardData="result" :has-background-image="true" />
      </div>
    </div>
    <div class="list-result container no-results" v-else>
      <p>Nenhum resultado encontrado.</p>
    </div>
    <div class="pagination-controls" v-if="totalPages > 1">
      <v-pagination v-model="currentPage" :length="totalPages" color="primary" active-color="pink"
        @input="searchProjects"></v-pagination>
    </div>
  </v-app>
</template>

<script>
import ProjectCard from '@/components/cards/ProjectCard.vue';
import { getGenders, getLanguages, getProjectType, getSearchProjects } from '../server/workService.js';
import { projectPath } from '@/utils/projectRoutes';

export default {
  name: 'SeriesViews',
  components: {
    ProjectCard
  },
  data() {
    return {
      model: null,
      tags: [],
      tagsLang: [],
      tagsTypes: [],
      searchQuery: "",
      projects: [],
      filteredResults: [],
      gender_id: null,
      language_id: null,
      type_id: null,
      currentPage: 1,
      totalPages: 1,
      showMenu: true
    };
  },
  async created() {
    this.tags = await getGenders();
    this.tagsLang = await getLanguages();
    this.tagsTypes = await getProjectType();
  },
  methods: {
    scrollTags(direction) {
      const slider = this.$refs.tagsSlider;
      const scrollAmount = 200; // Quantidade de pixels para rolar por clique
      slider.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth',
      });
    },
    async searchFilter(val) {
      const params = {
        name: val,
      };
      const results = await getSearchProjects(params);
      this.filteredResults = results.data;
    },
    async searchProjects(page = 1) {
      try {
        const params = {
          name: this.searchQuery,
          gender_id: this.gender_id,
          language_id: this.language_id,
          project_type_id: this.type_id,
          page,
        };
        const results = await getSearchProjects(params);
        this.projects = results.data;
        this.currentPage = results.current_page;
        this.totalPages = results.last_page;
      } catch (error) {
        console.error("Erro ao buscar projetos:", error);
      }
    },
    handleFilter(selectedId, type) {
      if (type === 'gender') {
        this.gender_id = this.gender_id === selectedId ? null : selectedId;
      } else if (type === 'language') {
        this.language_id = this.language_id === selectedId ? null : selectedId;
      } else if (type === 'type') {
        this.type_id = this.type_id === selectedId ? null : selectedId;
      }
      this.searchProjects();
    },
    projectPath,
  },
  mounted() {
    let urlParams = this.$route.query;
    if (urlParams && urlParams.q) {
      this.searchQuery = urlParams.q;
    }
    this.searchProjects();
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 0 !important;
}

.search-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 600px;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 8px;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-avatar {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}

.btn-search {
  padding: 8px;
  background: #f0f0f0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.tags-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.tags-slider,
.tags-container {
  scrollbar-width: none;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  padding: 8px;
}

.tags-container::-webkit-scrollbar {
  display: none !important;
  /* Oculta a barra no Chrome, Safari e Edge */
}

.tags-slider .tag-button {
  width: auto;
}

.tag-group {
  display: flex;
  gap: 8px;
}

.tag-button {
  padding: 6px 12px !important;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.tag-button.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}
</style>


<style scoped>
.result-title {
  width: 100%;
}

.container-result {
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin: 0 auto;
  /* Garante que o contêiner ocupe toda a largura disponível */
}

.result-item {
  display: flex;
  /* Para o ProjectCard interno se ajustar bem */
  flex-wrap: wrap;
  box-sizing: border-box;
  cursor: pointer;
  width: 50%;
  /* 2 colunas no mobile */
  padding: 10px;
  /* Opcional: espaçamento interno */
  color: inherit;
  text-decoration: none;
}

@media (min-width: 1440px) {
  .container-result {
    max-width: 85% !important;
  }
}

/* Acima de 500px: 3 colunas */
@media (min-width: 500px) {
  .result-item {
    width: 33.33%;
    /* 3 colunas */
  }
}

/* Acima de 990px: 5 colunas */
@media (min-width: 990px) {
  .result-item {
    width: 20%;
    /* 5 colunas */
  }
}

.app-main {
  background-color: #000000 !important;
  max-width: 1900px;
  margin: 0px auto !important;
}

.list-result {
  display: flex;
  flex-wrap: wrap;
  max-width: 1900px;
  margin: 0px auto !important;
  gap: 16px;
}

/* Ajustes para tablets */
@media (min-width: 600px) {
  .result-item {
    flex: 1 1 calc(25% - 16px);
    /* 4 itens por linha em tablets */
  }
}

/* Ajustes para desktop */
@media (min-width: 960px) {
  .result-item {
    flex: 1 1 calc(25% - 16px);
    /* 4 itens por linha em desktop */
  }
}

@media (min-width: 1440px) {
  .result-item {
    flex: 1 1 calc(20% - 16px);
    /* 5 itens por linha */
  }
}

.pagination-controls {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.tag-button.active {
  background-color: #66218E;
  color: white;
}

.result-title {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.pa-0 {
  margin-top: 70px;
}

.tag-button {
  background-color: #5c2a75 !important;
  color: white;
}

.tag-button.active {
  background-color: #7f47a6;
}

.btn-search {
  height: 50px !important;
  background-color: #66218E !important;
}

.v-icon {
  color: white !important;
}

@media (max-width: 420px) {
  .tag-button {
    font-size: 8px;
    padding: 0px 4px !important;
  }

  .tags-slider {
    max-width: 100% !important;
  }

  .v-icon {
    display: none;
  }
}

.result-image {
  width: 145px;
  height: 230px;
}

.no-results {
  text-align: center;
  margin-top: 32px;
}

.app-main {
  padding: 4px 8px;
  margin-top: 40px !important;
  background-color: #000000 !important;
}

.app-main h1 {
  color: #fff;
  font-size: 26px;
  font-weight: 300;
}

.list-result {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.pagination {
  margin: 50px 0px;
}

.tags-row {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  margin-top: 10px;
}

.tags-slider {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0 10px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  /* Firefox */
}

.tags-slider::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari */
}

.tag-button {
  margin: 0 5px;
  flex-shrink: 0;
}

.arrow-button {
  background: #141414ee;
  border: 1px solid #3b3838;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  transition: opacity 0.3s;
}

.arrow-button:hover {
  background: #383636;
}

.left-arrow {
  left: 0;
}

.right-arrow {
  right: 0;
}

/* Esconder botões de seta no mobile */
@media (max-width: 768px) {
  .arrow-button {
    display: none;
  }

  .tags-slider {
    overflow-x: auto;
    /* Permite rolagem manual no mobile */
  }
}
</style>
